<section class="page">
  <div class="header-container separator">
    <div class="header">{{'VIEW.MAIN.MAIN.PRESCRIPTIONS' | translate}}</div>
  </div>

  <div class="content">
    <app-data-grid *ngIf="data" [data]="data.content"
                   [criteria]="criteria"
                   [context]="{ host: this }"
                   [selectionEnabled]="false"
                   [showFilters]="true"
                   [showSearch]="true"
                   [showPagination]="true"
                   [pageTotal]="data.totalPages" [itemTotal]="data.totalElements"
                   (criteriaChanged)="onCriteriaChanged($event)"
                   [columns]="$any([
                    { colId: '1', headerName: ('VIEW.MAIN.PRESCRIPTION.DATA.CREATED_DATE' | translate), maxWidth: 140, field: 'createdDate', suppressSizeToFit: true, cellRendererFramework: DataGridTemplateCellRendererComponent, cellRendererParams: { ngTemplate: dateTemplate, preventSelection: false } },
                    { colId: '2', headerName: ('VIEW.MAIN.PRESCRIPTION.DATA.STATUS' | translate), maxWidth: 100, field: 'status', suppressSizeToFit: true, cellRendererFramework: DataGridTemplateCellRendererComponent, cellRendererParams: { ngTemplate: statusTemplate, preventSelection: false } },
                    { colId: '3', headerName: ('VIEW.MAIN.PATIENT.DATA.FIRST_NAME' | translate), maxWidth: 140, field: 'patientFirstName', suppressSizeToFit: true },
                    { colId: '4', headerName: ('VIEW.MAIN.PATIENT.DATA.LAST_NAME' | translate), maxWidth: 140, field: 'patientLastName', suppressSizeToFit: true },
                    { colId: '5', headerName: ('VIEW.MAIN.PATIENT.DATA.PHONE' | translate), maxWidth: 150, field: 'patientPhone', suppressSizeToFit: true },
                    { colId: '6', headerName: ('VIEW.MAIN.PATIENT.DATA.EMAIL' | translate), minWidth: 150, field: 'patientEmail', flex: 1, cellRendererFramework: DataGridTemplateCellRendererComponent, cellRendererParams: { ngTemplate: emailTemplate, preventSelection: false } },
                    { colId: '7', headerName: ('COMMON.ACTIONS' | translate), headerClass: 'header-right', cellClass: 'cell-right', sortable: false, minWidth: 150, cellRendererFramework: DataGridTemplateCellRendererComponent, cellRendererParams: { ngTemplate: menuTemplate, preventSelection: false } },
                  ])">
      <app-data-grid-filters>
        <div class="filter">
          <ng-select name="filter-status"
                     class="sm"
                     [placeholder]="'VIEW.MAIN.PRESCRIPTION.FILTER.STATUS.PLACEHOLDER' | translate"
                     [searchable]="false"
                     [(ngModel)]="criteria.status" (ngModelChange)="onStatusFilterChanged($event)">
            <ng-option *ngFor="let status of statuses"
                       [value]="status">{{ status | prefix:'ENUM.PRESCRIPTION_STATUS.' | translate }}</ng-option>
          </ng-select>
        </div>
      </app-data-grid-filters>
    </app-data-grid>
  </div>
</section>

<!--Templates-->
<ng-template #statusTemplate let-value="value">
  <span>{{value | prefix: 'ENUM.PRESCRIPTION_STATUS.' | translate}}</span>
</ng-template>

<ng-template #dateTemplate let-value="value">
  <span>{{value | date:Constant.DATE_FORMAT}}</span>
</ng-template>

<ng-template #emailTemplate let-value="value">
  <a href="mailto:{{value}}">{{value}}</a>
</ng-template>

<ng-template #menuTemplate let-data>
  <button type="button"
          class="btn btn-link text-normal btn-link--black font-size-sm"
          (click)="goDetails(data)">{{'COMMON.SHOW_DETAILS' | translate}}</button>
</ng-template>
